export default __webpack_public_path__ + "static/media/hvacomdm140-2.26312f39.svg";